export const ROOT = '/tags';
export const MODULE = 'TAGS';
